import { render, staticRenderFns } from "./CheckDiscount.vue?vue&type=template&id=4f5219d7&scoped=true&"
import script from "./CheckDiscount.vue?vue&type=script&lang=js&"
export * from "./CheckDiscount.vue?vue&type=script&lang=js&"
import style0 from "./CheckDiscount.vue?vue&type=style&index=0&id=4f5219d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5219d7",
  null
  
)

export default component.exports